/** Adresse de l'API, figée au build (VITE_API_URL), comme pour le front élève. */
export const API_URL: string = import.meta.env.VITE_API_URL ?? 'http://localhost:3001';

/** Ancien back-office, proposé tant qu'un écran n'est pas refait. */
export const LEGACY_ADMIN_URL: string = import.meta.env.VITE_LEGACY_ADMIN_URL ?? 'https://admin.sokona.com-ai.fr';
